import { createApp } from 'vue'
import "./index.js";
import PhonebookEditor from "./editor.vue";
import PhonebookIndex from "./list.vue"


createApp({
  components: {
    PhonebookEditor,
    PhonebookIndex
  }
}).mount("#app");
createApp({
  components: { PhonebookIndex }
}).mount("#search");
